import { render, staticRenderFns } from "./smsexample.vue?vue&type=template&id=71771c5b&"
import script from "./smsexample.vue?vue&type=script&lang=js&"
export * from "./smsexample.vue?vue&type=script&lang=js&"
import style0 from "./smsexample.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports